
/**
 * Configuration utility for controlling debug output
 */

// Set to true to enable verbose debugging in development
export const DEBUG_ENABLED = process.env.NODE_ENV !== 'production';

// Specific debug channels that can be enabled/disabled
export const DEBUG_CHANNELS = {
  SALES: true,
  NETWORK: true,
  API: true,
  TRANSACTIONS: true,
};

/**
 * Debug logger that only outputs in development or when explicitly enabled
 */
export const debugLog = (channel: keyof typeof DEBUG_CHANNELS, message: string, data?: any) => {
  if (DEBUG_ENABLED && DEBUG_CHANNELS[channel]) {
    console.log(`[${channel}] ${message}`, data !== undefined ? data : '');
  }
};

/**
 * Error logger that only outputs full details in development
 */
export const debugError = (channel: keyof typeof DEBUG_CHANNELS, message: string, error?: any) => {
  if (DEBUG_ENABLED && DEBUG_CHANNELS[channel]) {
    console.error(`[${channel}] ${message}`, error !== undefined ? error : '');
  } else if (error) {
    // In production, log minimal error info but not full objects/stacks
    console.error(`[${channel}] ${message}: ${error.message || 'Unknown error'}`);
  }
};
